import React from "react";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  FieldError,
} from "react-hook-form";
import { Typography, Box, FormHelperText, InputLabel } from "@mui/material";
import TextEditor from "../TextEditor/TextEditor";

interface RichTextFormProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  disabled?: boolean;
  rules?: Record<string, any>;
}

const RichTextForm = <T extends FieldValues>({
  control,
  name,
  label,
  disabled = false,
  rules,
}: RichTextFormProps<T>) => {
  const isRequired = !!rules?.required;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <Box>
          {label && <InputLabel required={isRequired}>{label}</InputLabel>}
          <TextEditor
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
          />
          {fieldState.error && (
            <FormHelperText error sx={{ mt: 1 }}>
              {fieldState.error.message}
            </FormHelperText>
          )}
        </Box>
      )}
    />
  );
};

export default RichTextForm;
``;
